import React from 'react';
import s from './s.module.less';

interface ContentWrapperProps {
    children: React.ReactNode;
    title: string;
    description: string;
    showInfo?: boolean;
}

const ContentWrapper: React.FC<ContentWrapperProps> = ({ children, title, description, showInfo = true }) => {
    return (
        <div className={s.contentWrapper}>
            {showInfo && (
                <>
                    <h3 className={s.title}>{title}</h3>
                    <p className={s.description}>{description}</p>
                </>
            )}
            {children}
        </div>
    );
};

export default ContentWrapper;
